export default __webpack_public_path__ + "static/product-nav-reliability-analytics-8462613b3844add4ae6a9cc75af17e22.svg";